import React, { forwardRef } from 'react';
import Icon, { generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
const draw16px = 'M12.22 12.22h-1.773V9.44c0-.667 0-1.52-.927-1.52s-1.067.727-1.067 1.473v2.834H6.667V6.5h1.706v.78a1.869 1.869 0 0 1 1.687-.927c1.8 0 2.134 1.187 2.134 2.727ZM4.666 5.713a1.033 1.033 0 1 1 .734-.307 1.033 1.033 0 0 1-.734.307Zm.894 6.514H3.78V6.5h1.78ZM13.114 2H2.886A.874.874 0 0 0 2 2.866v10.268a.874.874 0 0 0 .886.866h10.228a.882.882 0 0 0 .886-.866V2.866A.882.882 0 0 0 13.114 2Z';
const draw24px = 'M18.33,18.33H15.67V14.16c0-1,0-2.28-1.39-2.28s-1.6,1.09-1.6,2.21v4.25H10V9.75h2.56v1.17a2.79,2.79,0,0,1,2.53-1.39c2.7,0,3.2,1.78,3.2,4.09ZM7,8.57a1.55,1.55,0,1,1,1.1-.46A1.57,1.57,0,0,1,7,8.57Zm1.34,9.77H5.67V9.75H8.34ZM19.67,3H4.33A1.3,1.3,0,0,0,3,4.3V19.7A1.3,1.3,0,0,0,4.33,21H19.67A1.31,1.31,0,0,0,21,19.7V4.3A1.31,1.31,0,0,0,19.67,3Z';
const icons = {
  _16: {
    d: draw16px,
    viewBox: VIEWBOXES._16
  },
  _24: {
    d: draw24px,
    viewBox: VIEWBOXES._24
  }
};
const LogoLinkedinIcon = /*#__PURE__*/forwardRef(generateRenderedIcon(icons, 'logoLinkedin'));
LogoLinkedinIcon.displayName = 'LogoLinkedinIcon';
LogoLinkedinIcon.propTypes = Icon.propTypes;
LogoLinkedinIcon.renderIcon = props => /*#__PURE__*/React.createElement(LogoLinkedinIcon, props);
export default LogoLinkedinIcon;
//# sourceMappingURL=LogoLinkedinIcon.js.map